import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth, formatApiError } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { KeyRound, LogOut } from "lucide-react";
import { toast } from "sonner";

export const AccountMenu = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current_password: "", new_password: "" });

  const save = async () => {
    try {
      await api.post("/auth/change-password", form);
      toast.success("Şifre değiştirildi"); setOpen(false); setForm({ current_password: "", new_password: "" });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="px-2 md:px-4 py-3 border-t border-[#DCCFB8]" data-testid="account-menu">
      <p className="hidden md:block text-[11px] text-[#6B5B4A] truncate mb-2" data-testid="account-email">{user?.name ? `${user.name} · ` : ""}{{ admin: "Yönetici", cutter: "Kesimci", shipper: "Sevkiyatçı" }[user?.role]}<br />{user?.email}</p>
      <div className="flex flex-col md:flex-row gap-1">
        <button onClick={() => setOpen(true)} title="Şifre Değiştir" data-testid="change-password-btn"
          className="flex items-center justify-center md:justify-start gap-1.5 text-xs text-[#6B5B4A] hover:text-[#B45309] px-2 py-1.5 rounded hover:bg-[#EFE6D6]">
          <KeyRound className="w-3.5 h-3.5" /><span className="hidden md:inline">Şifre</span></button>
        <button onClick={logout} title="Çıkış" data-testid="logout-btn"
          className="flex items-center justify-center md:justify-start gap-1.5 text-xs text-[#6B5B4A] hover:text-[#EF4444] px-2 py-1.5 rounded hover:bg-[#EFE6D6]">
          <LogOut className="w-3.5 h-3.5" /><span className="hidden md:inline">Çıkış</span></button>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#FFFBF4] border-[#DCCFB8] max-w-sm" data-testid="change-password-dialog">
          <DialogHeader><DialogTitle className="font-display text-xl uppercase">Şifre Değiştir</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <Input type="password" placeholder="Mevcut şifre" value={form.current_password} data-testid="current-password"
              onChange={(e) => setForm({ ...form, current_password: e.target.value })} className="h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
            <Input type="password" placeholder="Yeni şifre (en az 8 karakter)" value={form.new_password} data-testid="new-password"
              onChange={(e) => setForm({ ...form, new_password: e.target.value })} className="h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
          </div>
          <DialogFooter>
            <Button onClick={save} data-testid="change-password-save" className="bg-[#D97706] hover:bg-[#B45309] text-white">Kaydet</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
